export default "__VITE_ASSET__Bznq7qTG__"